import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import noop from 'lodash/noop'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import { i18n } from '../../index'
import { fetchStation, removeStationUser } from '../../station/stationQueries'
import type { StationStore } from '../../station/stationTypes'
import type { User } from '../users/userTypes'
import css from './employeeList.css'

const updateCacheOnDelete = (stationId: string, userId: string) => (cache: any) => {
  const { station } = cache.readQuery({
    query: fetchStation,
    variables: { id: stationId },
  })

  cache.writeQuery({
    query: fetchStation,
    data: {
      station: {
        ...station,
        users: station.users.filter((user) => user.id !== userId),
      },
    },
  })
}

type EmployeeRowProps = {
  stationId: string
  stationStore: StationStore
  data: User
}

class EmployeeRow extends React.PureComponent<EmployeeRowProps> {
  onDelete = (onMutate: (...props: any) => any, userId: string) => {
    const { stationId } = this.props

    onMutate({
      variables: { stationId, userId },
      update: updateCacheOnDelete(stationId, userId),
    })
  }

  render() {
    const { data } = this.props

    return (
      <TableRow>
        <TableCell className={css.tableCell}>{data.name}</TableCell>
        <TableCell className={css.tableCell}>{i18n.t(`admin.user.${data.userType}`)}</TableCell>
        <TableCell className={css.actionsCell} align='right'>
          <Mutation mutation={removeStationUser}>
            {(onMutate) => <DeleteButton onClick={() => (data.id ? this.onDelete(onMutate, data.id) : noop)} />}
          </Mutation>
        </TableCell>
      </TableRow>
    )
  }
}

export default EmployeeRow
